<template>
  <div class="sidebar"
       v-if="!collapse">
    <el-menu class="sidebar-el-menu"
             :default-active="onRoutes"
             :collapse="collapse"
             background-color="#324157"
             text-color="#f5f5f5"
             active-text-color="#20a0ff"
             unique-opened
             router>
      <template v-for="item in items">
        <template v-if="item.subs">
          <el-submenu :index="item.index"
                      :key="item.index">
            <template slot="title">
              <i :class="item.icon"></i>
              <span slot="title">{{ item.title }}</span>
            </template>
            <template v-for="subItem in item.subs">
              <el-submenu v-if="subItem.subs"
                          :index="subItem.index"
                          :key="subItem.index">
                <template slot="title">{{ subItem.title }}</template>
                <el-menu-item v-for="(threeItem, i) in subItem.subs"
                              :key="i"
                              :index="threeItem.index">{{ threeItem.title }}</el-menu-item>
              </el-submenu>
              <el-menu-item v-else
                            :index="subItem.index"
                            :key="subItem.index">{{ subItem.title }}</el-menu-item>
            </template>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :index="item.index"
                        :key="item.index">
            <i :class="item.icon"></i>
            <span slot="title">{{ item.title }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
import bus from '../common/bus'
import { computePermission, getStorage } from '@/utils/helper'
import routerMenu from './routerMenu'

const menus = [
  {
    icon: 'icon icon-home',
    index: '/dashboard',
    title: '总览',
  },
  {
    icon: 'icon icon-base',
    index: '/base',
    title: '基础数据',
    subs: [
      {
        index: '/college/list',
        title: '院校管理',
      },
      {
        index: '/major/list',
        title: '专业管理',
      },
      {
        index: '/subject/list',
        title: '科目管理',
      },
      {
        index: '/teacher/list',
        title: '教师管理',
      },
      {
        index: '/service/list',
        title: '金牌客服',
      },
    ],
  },
  {
    icon: 'icon icon-content',
    index: '/content',
    title: '内容管理',
    subs: [
      {
        index: '/article/list',
        title: '文章资讯',
      },
      {
        index: '/exam/list',
        title: '在线题库',
      },
      {
        index: '/read/list',
        title: '阅读资料',
      },
      {
        index: '/course/list',
        title: '在线课程',
      },
      {
        index: '/material/list',
        title: '实体资料',
      },
      {
        index: '/consult/list',
        title: '参考书籍',
      },
      {
        index: '/section',
        title: '内容版块',
        subs: [
          {
            index: '/section/list',
            title: '常规版块',
          },
          {
            index: '/section/college/list',
            title: '院校专业',
          },
        ],
      },
      {
        index: '/recommend',
        title: '内容推荐',
        subs: [
          {
            index: '/recommend/list',
            title: '推荐列表',
          },
          {
            index: '/recommend/position',
            title: '推荐位置',
          },
        ],
      },
      {
        index: '/res',
        title: '资源管理',
        subs: [
          {
            index: '/resource/paper',
            title: '试卷管理',
          },
          {
            index: '/resource/trash',
            title: '内容回收站',
          },
        ],
      },
    ],
  },
  {
    icon: 'icon icon-member',
    index: '/application',
    title: '应用管理',
    subs: [
      {
        index: '/product/config',
        title: '产品配置',
      },
      {
        index: '/menu',
        title: '菜单管理',
        subs: [
          {
            index: '/menu/list',
            title: '菜单列表',
          },
          {
            index: '/menu/position',
            title: '菜单位置',
          },
        ],
      },
      {
        index: '/ad',
        title: '广告管理',
        subs: [
          {
            index: '/ad/list',
            title: '广告列表',
          },
          {
            index: '/ad/position',
            title: '广告位置',
          },
        ],
      },
      {
        index: '/client',
        title: '客户端管理',
      },
      {
        index: '/configure',
        title: '系统配置',
      },
      {
        index: '/agreement',
        title: '协议管理',
      },
    ],
  },
  {
    icon: 'icon icon-operation',
    index: '/operation',
    title: '运营管理',
    subs: [
      {
        index: '/page/list',
        title: '乐高原创',
      },
      {
        index: '/activity/list',
        title: '拼团管理',
      },
      {
        index: '/coupon/list',
        title: '优惠券管理',
      },
      {
        index: '/group/list',
        title: 'QQ群管理',
      },
      {
        index: '/points/task/list',
        title: '积分任务',
      },
      {
        index: '/college/menu/list',
        title: '院校菜单',
      },
    ],
  },
  {
    icon: 'icon icon-project',
    index: '/project',
    title: '项目管理',
    subs: [
      {
        index: '/enrol',
        title: '院校报考',
        subs: [
          {
            index: '/enrol/college',
            title: '院校查询',
          },
          {
            index: '/enrol/major',
            title: '专业查询',
          },
          {
            index: '/enrol/user',
            title: '考生查询',
          },
        ],
      },
    ],
  },
  {
    icon: 'icon icon-order',
    index: '/order',
    title: '订单管理',
    subs: [
      {
        index: '/order/list',
        title: '订单管理',
      },
      {
        index: '/order/booking',
        title: '学长预约',
      },
      {
        index: '/order/commodityChange',
        title: '商品兑换',
      },
    ],
  },
  {
    icon: 'icon icon-member',
    index: '/member',
    title: '用户管理',
    subs: [
      {
        index: '/member/list',
        title: '用户管理',
      },
      {
        index: '/member/withdraw',
        title: '提现审核',
      },
      {
        index: '/member/charge',
        title: '返佣费率',
      },
      {
        index: '/member/notice',
        title: '消息推送',
      },
    ],
  },
  {
    icon: 'icon icon-merchant',
    index: '/senior',
    title: '学长管理',
    subs: [
      {
        index: '/senior/apply',
        title: '认证申请',
      },
      {
        index: '/senior/list',
        title: '学长管理',
      },
      {
        index: '/senior/order',
        title: '学长订单',
      },
      {
        index: '/senior/withdraw',
        title: '提现审核',
      },
      {
        index: '/senior/charge',
        title: '服务费率',
      },
      {
        index: '/senior/topicMangement',
        title: '专题管理',
      },
    ],
  },
  {
    icon: 'icon icon-permission',
    index: '/admin',
    title: '权限管理',
    subs: [
      {
        index: '/admin/list',
        title: '管理员管理',
      },
      {
        index: '/role/list',
        title: '角色管理',
      },
      {
        index: '/rule/list',
        title: '权限管理',
      },
    ],
  },
]

export default {
  data() {
    return {
      collapse: false,
      items: [],
    }
  },
  computed: {
    onRoutes() {
      let path = this.$route.path
      return this.computeRoute(this.items, path)
    },
  },
  created() {
    // 菜单判断
    // this.items = menus

    const adminInfo = getStorage('admin_user')

    // 超级管理员免检
    if (adminInfo && adminInfo.username == 'admin') {
      this.items = routerMenu
    } else {
      this.items = JSON.parse(JSON.stringify(routerMenu)).filter((item) => {
        return this.computeRoute2(item)
      })
    }

    // 通过 Event Bus 进行组件间通信，来折叠侧边栏
    bus.$on('collapse', (msg) => {
      this.collapse = msg
      bus.$emit('collapse-content', msg)
    })
  },
  methods: {
    computeRoute(routes, path, list = []) {
      list = list || []
      routes.forEach((item) => {
        if (path.includes(item.index)) {
          list.push(item.index)
        }
        // 兼容性匹配
        if (item.index.includes('/list')) {
          const tempIndex = item.index.replace('/list', '')
          if (path.includes(tempIndex)) {
            list.push(item.index)
          }
        }
        if (item.subs) {
          this.computeRoute(item.subs, path, list)
        }
      })
      list.sort((a, b) => b.length - a.length)
      return list[0] || ''
    },
    computeRoute2(item) {
      if (item.subs) {
        item.subs = item.subs.filter((sub) => {
          return this.computeRoute2(sub)
        })
      }
      return computePermission(item.index)
    },
  },
}
</script>

<style scoped lang="less">
.sidebar {
  display: block;
  position: absolute;
  left: 0;
  top: 70px;
  bottom: 0;
  overflow-y: scroll;

  /deep/ .el-submenu .el-menu-item {
    min-width: auto;
  }

  .icon {
    font-size: 24px;
    margin-right: 12px;
  }
}
.sidebar::-webkit-scrollbar {
  width: 0;
}
.sidebar-el-menu:not(.el-menu--collapse) {
  width: 180px;
}
.sidebar > ul {
  height: 100%;
}
i {
  color: #f5f5f5;
}
</style>
